import React from 'react';
import Reveal from '../Reveal';
import { ctaImage } from '../../mock';

export default function QuoteBand() {
  return (
    <section className="relative h-[520px] md:h-[620px] w-full overflow-hidden">
      <img
        src={ctaImage}
        alt="Malibu coastline at dusk"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/45" />
      <div className="relative z-10 h-full flex items-center justify-center text-center text-white px-6">
        <Reveal className="max-w-3xl">
          <div className="font-sans-ui text-[10px] tracking-[0.4em] mb-8">
            Los Angeles &mdash; California
          </div>
          <h3 className="font-serif-display text-[32px] md:text-[48px] lg:text-[58px] leading-[1.15] italic font-light">
            &ldquo;A house is the last honest thing you build.
            <br className="hidden md:block" /> You will live with every inch of it.&rdquo;
          </h3>
        </Reveal>
      </div>
    </section>
  );
}
